@if (visible) {
  <div class="export-template-dialog__backdrop" (click)="cancel()"></div>
  <div
    class="export-template-dialog__card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="export-template-dialog-title"
  >
    <div class="export-template-dialog__modal-head">
      <div
        id="export-template-dialog-title"
        class="export-template-dialog__modal-title"
      >
        {{ 'consultant.export.templates.title' | translate }}
      </div>
      <button
        class="export-template-dialog__modal-x"
        type="button"
        [attr.aria-label]="'general.close' | translate"
        (click)="cancel()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="export-template-dialog__modal-body">
      <div class="export-template-dialog__scroll">
        <table class="export-template-dialog__table">
          <thead>
            <tr>
              <td class="export-template-dialog__corner"></td>
              @for (variant of variants; track variant) {
                <th scope="col" class="export-template-dialog__variant-head">
                  {{ variantLabelKey(variant) | translate }}
                </th>
              }
            </tr>
          </thead>
          @for (group of groups; track group.group) {
            <tbody>
              <tr class="export-template-dialog__group-row">
                <th
                  scope="rowgroup"
                  colspan="5"
                  class="export-template-dialog__group"
                >
                  {{ groupLabelKey(group.group) | translate }}
                </th>
              </tr>
              @for (template of group.templates; track template) {
                <tr
                  class="export-template-dialog__row"
                  [attr.data-template]="template"
                >
                  <th scope="row" class="export-template-dialog__name">
                    {{ templateLabelKey(template) | translate }}
                  </th>
                  @for (variant of variants; track variant) {
                    <td
                      class="export-template-dialog__cell"
                      [attr.data-variant]="variant"
                    >
                      @if (offers(template, variant)) {
                        <mat-checkbox
                          [checked]="isVariantChosen(template, variant)"
                          [aria-label]="
                            template === 'PLAIN_TEXT'
                              ? (templateLabelKey(template) | translate)
                              : (templateLabelKey(template) | translate) +
                                ' – ' +
                                (variantLabelKey(variant) | translate)
                          "
                          (change)="toggleVariant(template, variant)"
                        ></mat-checkbox>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
    </div>

    <div class="export-template-dialog__modal-foot">
      <div class="export-template-dialog__status" aria-live="polite">
        @if (canConfirm) {
          <span class="export-template-dialog__count">{{
            (fileCount === 1
              ? 'consultant.export.templates.fileCount.one'
              : 'consultant.export.templates.fileCount.other'
            ) | translate: { count: fileCount }
          }}</span>
        } @else {
          <small class="export-template-dialog__error">{{
            'consultant.export.templates.error' | translate
          }}</small>
        }
      </div>
      <div class="export-template-dialog__modal-actions">
        <button
          type="button"
          class="export-template-dialog__btn-text export-template-dialog__cancel"
          (click)="cancel()"
        >
          {{ 'general.cancel' | translate }}
        </button>
        <button
          type="button"
          class="export-template-dialog__btn-primary export-template-dialog__confirm"
          [disabled]="!canConfirm"
          (click)="confirm()"
        >
          {{ 'consultant.export.templates.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
}
